import * as React from 'react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import * as FieldStyles from './SharedField.scss';
import { css } from '@uifabric/utilities/lib/css';
import FieldStrings from '../FieldStrings.resx';

export interface ISharedFieldProps extends React.HTMLProps<HTMLDivElement> {

  /**This is the text to be displayed for this field */
  text?: string | undefined;

  /**This is the tooltip title to be displayed for this field */
  title?: string | undefined;

  /**This tells if this field is shared or private */
  shared?: boolean | undefined;

  /** Text to put in aria-label. If not specified, defaults to rendered text */
  ariaLabel?: string;

  /** On click function for the field */
  onClick?: (ev: React.MouseEvent<HTMLElement>) => void;

  /**Icon that needs to be displayed for shared field */
  iconName?: string;

  /**Image text to be displayed for shared field */
  imageAlt?: string;

}
export const SharedField: React.StatelessComponent<ISharedFieldProps> = (props: ISharedFieldProps) => {
  let { text, title, shared, ariaLabel, onClick, iconName, imageAlt } = props;

  const defaultSharedText = shared ? FieldStrings.sharedColumnSharedFieldText :
    (shared === undefined ? '' : FieldStrings.sharedColumnPrivateFieldText);
  const sharedText = text ? text : defaultSharedText;

  title = title || sharedText;     // Default to text if no ariaLabel given
  ariaLabel = ariaLabel || sharedText;    // Default to text if no ariaLabel given
  imageAlt = imageAlt || '';
  iconName = iconName || 'People';

  const showIcon = !!(iconName && shared);

  return (
    <div
      className={ `${FieldStyles.sharedFieldRender}` }
      data-is-focusable='true'
      title={ title }
      onClick={ onClick }
      role={ onClick ? 'button' : '' }
      aria-label={ ariaLabel }
    >
      { showIcon && (
        <Icon iconName={ iconName } { ...{ alt: imageAlt } } />
      ) }
      { showIcon && ' ' }
      <span className={ css({ [`${FieldStyles.clickableSharedField}`]: onClick }) }>{ sharedText }</span>
    </div>
  );
};